import React from 'react';
import { motion } from 'framer-motion';
type Day = {
  day: string;
  title: string;
  text: string;
};
const DAYS: Day[] = [{
  day: 'Día 1',
  title: 'Aceptar el caos sin que te consuma',
  text: 'Dejar de pelear contra lo que ya pasó para recuperar tu energía.'
}, {
  day: 'Día 2',
  title: 'Encontrar a Dios en lo cotidiano',
  text: 'Cuando el miedo es grande, la fe se encuentra en lo pequeño.'
}, {
  day: 'Día 3',
  title: 'Soltar lo que no controlas',
  text: 'La tierra se mueve. Tú decides dónde pones tu paz.'
}, {
  day: 'Día 4',
  title: 'Un ritual pequeño de paz',
  text: '5 minutos al día para que tu cuerpo y tu mente vuelvan a sentirse seguros.'
}, {
  day: 'Día 5',
  title: 'Elegir la esperanza como decisión diaria',
  text: 'Como el fénix venezolano — no porque el fuego no te tocó, sino porque decides que no será el final.'
}];
export function DaysTimeline() {
  return <section className="w-full bg-[#faf4ec] px-6 py-16 sm:py-24" data-id="element-34" data-mp="6dygvxuxoclx">
      <div className="mx-auto max-w-2xl text-center" data-id="element-35" data-mp="1geq3q993si9u">
        <p className="mb-4 text-xs uppercase tracking-[0.3em] text-[#b06a4a]" data-id="element-36" data-mp="1lci31oc2v6o2">
          Qué encontrarás
        </p>
        <h2 className="font-serif text-2xl font-medium leading-snug text-[#3a2e28] sm:text-3xl" data-id="element-37" data-mp="16o3v4yzt0s0n">
          Cinco días para volver a tu centro
        </h2>
      </div>

      <div className="relative mx-auto mt-14 max-w-xl" data-id="element-38" data-mp="1bkc5lz323x1h">
        <div className="absolute left-[19px] top-2 bottom-2 w-px bg-[#e0cdba] sm:left-1/2" aria-hidden="true" data-id="element-39" data-mp="xm4c6158bdv2" />
        <ol className="space-y-8" data-id="element-40" data-mp="11m64hjp2quxo">
          {DAYS.map((d, i) => <motion.li key={d.day} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: i * 0.08
        }} className="relative pl-14 sm:pl-0" data-id="element-41" data-mp="nqas7wp6ki39" data-mpi={i}>
              <span className="absolute left-0 top-1 flex h-10 w-10 items-center justify-center rounded-full bg-[#b06a4a] font-serif text-sm font-semibold text-[#faf4ec] shadow-md sm:left-1/2 sm:-translate-x-1/2" aria-hidden="true" data-id="element-42" data-mp="2mzhlk4s77s31">
                {i + 1}
              </span>
              <div className="rounded-2xl border border-[#ecdfd0] bg-white/70 p-6 shadow-sm sm:mr-auto sm:w-[calc(50%-2.5rem)] sm:odd:ml-auto sm:odd:mr-0" data-id="element-43" data-mp="26nnv6v0d42wu">
                <p className="text-xs font-semibold uppercase tracking-wider text-[#c9a24b]" data-id="element-44" data-mp="34aedf9fa9xhf">
                  {d.day}
                </p>
                <h3 className="mt-2 font-serif text-lg font-medium text-[#3a2e28]" data-id="element-45" data-mp="2ul369sbyj2w6">
                  {d.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-[#7a6a5f]" data-id="element-46" data-mp="2pli99ngcl4m3">
                  {d.text}
                </p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}